import { combineReducers } from 'redux';

import {
  adjustCreditRequest,
  adjustCreditSuccess,
  adjustCreditFail,
} from '../actions';
import { AdjustCreditResponse, CreditAction } from '../types';

const data = (state: AdjustCreditResponse | null = null, action: CreditAction) => {
  switch (action.type) {
    case adjustCreditFail.type:
    case adjustCreditRequest.type:
      return null;

    case adjustCreditSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading = (state = false, action: CreditAction) => {
  switch (action.type) {
    case adjustCreditRequest.type:
      return true;

    case adjustCreditFail.type:
    case adjustCreditSuccess.type:
      return false;

    default:
      return state;
  }
};

const error = (state = false, action: CreditAction) => {
  switch (action.type) {
    case adjustCreditFail.type:
      return true;

    case adjustCreditRequest.type:
    case adjustCreditSuccess.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  loading,
  error,
});
